<template>
    <div class="vx-row">

        <!-- TITLE COLOR -->
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
            <vx-card
                title="Comprar Bitcoin"
                title-color="primary"
                subtitle="Painel simples de compra">
                <p class="mb-3">Você pode especificar o valor em reais que deseja efetuar a compra.</p>
                <p class="mb-3">Você precisa ter saldo disponível na sua conta.</p>
                <div class="w-full mb-2">
                    <vs-input v-model.lazy="value_real" v-money="money" class="w-full" icon-pack="feather" label="Valor total da compra" icon="icon-alert-circle" placeholder="R$ 0,00" v-model="value_real" />
                </div>
                <div class="w-full">
                    <vs-input class="w-full" v-model="value_btc"  icon-pack="feather" icon="icon-alert-circle" label="Quantidade em Bitcoins" placeholder="0.00000000" />
                </div>
                <vs-divider></vs-divider>
                <div class="flex justify-between flex-wrap mb-5">
                    <span>
                        <p class="text-sm">R$ {{this.number_format(cotacao[0].rate, 2, ',', '.')}}</p>
                        <p class="text-grey">Cotação</p>
                    </span>
                    <span>
                        <p class="text-sm">{{taxa_btc}} (R$ {{taxa}})</p>
                        <p class="text-grey">Taxa</p>
                    </span>
                    <span>
                        <p class="text-sm">{{ total_liquido }}</p>
                        <p class="text-grey">Quantidade líquida</p>
                    </span>
                </div>
                <vs-button class="w-full mb-2" color="warning" type="border" @click="Depositar">Depositar</vs-button>
                <vs-button class="w-full mb-2" color="success" type="border" @click="Comprar">Comprar</vs-button>

            
            </vx-card>
        </div>

        <!-- TITLE COLOR -->
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
            <vx-card
                title="Vender Bitcoin"
                title-color="danger"
                subtitle="Painel simples de venda">
                <p class="mb-3">Você pode especificar o valor em bitcoins que deseja efetuar a venda.</p>
                <p class="mb-3">Você precisa ter saldo em bitcoins disponível na sua conta.</p>
                <div class="w-full">
                    <vs-input class="w-full" v-model.lazy="value_btc_sell"  v-model="value_btc_sell" v-money="crypto" icon-pack="feather" icon="icon-alert-circle" label="Quantidade em Bitcoins" placeholder="0.00000000" />
                </div>
                <div class="w-full mb-2">
                    <vs-input v-model="value_real_sell"  class="w-full" icon-pack="feather" label="Valor total da venda" icon="icon-alert-circle" placeholder="R$ 0,00" />
                </div>
                
                <vs-divider></vs-divider>
                <div class="flex justify-between flex-wrap mb-5">
                    <span>
                        <p class="text-sm">R$ {{this.number_format(cotacao[0].sell, 2, ',', '.')}}</p>
                        <p class="text-grey">Cotação</p>
                    </span>
                    <span>
                        <p class="text-sm">{{taxa_btc_sell}} (R$ {{taxa_sell}})</p>
                        <p class="text-grey">Taxa</p>
                    </span>
                    <span>
                        <p class="text-sm" color="warning">R$ {{ this.number_format(total_liquido_sell, 2, ',', '.') }}</p>
                        <p class="text-grey" color="warning">Quantidade líquida</p>
                    </span>
                </div>
                <vs-button class="w-full mb-2" color="warning" type="border" @click="Depositar">Depositar</vs-button>
                <vs-button class="w-full mb-2" color="danger" type="border" @click="Vender">Vender</vs-button>

            </vx-card>
        </div>

        <!-- TITLE COLOR -->
        <div class="vx-col w-1/2">
            <vx-card
                title="Minhas Ordens"
                title-color="primary"
                subtitle="Suas ordens de compra e venda em aberto">
                
                <vs-tabs :color="colorx">
                    <vs-tab @click="colorx = 'success'" label="Compra">
                      <div class="con-tab-ejemplo">
                        <vs-list>
                          <vs-list-header title="Minhas Ordens" color="success"></vs-list-header>
                            <div v-for="item in ordens_compra">
                              <vs-list-item  :title="item.title" :subtitle="item.subtitle">
                                <template  slot="avatar">
                                  <vs-avatar :src="cotacao[0].icon" color="#26302a" />
                                </template>
                                <vs-button class="w-full mb-2" color="danger" type="border" @click="CancelOrder(item.id_order)">Cancelar</vs-button>
                              </vs-list-item>
                            </div>
                      </vs-list>

                      </div>
                    </vs-tab>

                    <vs-tab @click="colorx = 'danger'" label="Venda">
                      <div class="con-tab-ejemplo">
                       <vs-list>
                          <vs-list-header title="Minhas Ordens" color="danger"></vs-list-header>
                            <div v-for="item in ordens_venda">
                              <vs-list-item  :title="item.title" :subtitle="item.subtitle">
                                <template  slot="avatar">
                                  <vs-avatar :src="cotacao[0].icon" color="#26302a" />
                                </template>
                                <vs-button class="w-full mb-2" color="danger" type="border" @click="CancelOrder(item.id_order)">Cancelar</vs-button>
                              </vs-list-item>
                            </div>
                      </vs-list>
                    </div>
                    </vs-tab>

                </vs-tabs>

            
            </vx-card>
        </div>
        <div class="vx-col w-1/2">
            <vx-card
                title="Ordens Mercado"
                title-color="warning"
                subtitle="Ordens do mercado de compra e venda em aberto">
                
                <vs-tabs :color="colorxx">
                    <vs-tab @click="colorxx = 'success'" label="Compra">
                      <div class="con-tab-ejemplo">
                      <vs-list>
                          <vs-list-header title="Ordens no Mercado" color="success"></vs-list-header>
                            <div v-for="item in ordens_mercado_compra">
                              <vs-list-item  :title="item.title" :subtitle="item.subtitle">
                                <template  slot="avatar">
                                  <vs-avatar :src="cotacao[0].icon" color="#26302a" />
                                </template>
                              </vs-list-item>
                            </div>
                      </vs-list>
                    </div>
                    </vs-tab>

                    <vs-tab @click="colorxx = 'danger'" label="Venda">
                      <div class="con-tab-ejemplo">
                      <vs-list>
                          <vs-list-header title="Ordens no Mercado" color="danger"></vs-list-header>
                            <div v-for="item in ordens_mercado_venda">
                              <vs-list-item  :title="item.title" :subtitle="item.subtitle">
                                <template  slot="avatar">
                                  <vs-avatar :src="cotacao[0].icon" color="#26302a" />
                                </template>
                              </vs-list-item>
                            </div>
                      </vs-list>
                    </div>
                    </vs-tab>

                </vs-tabs>

            
            </vx-card>
        </div>


    </div>

</template>

<script>
import {VMoney} from 'v-money'
export default{
  data() {
    return {
      card_bg_img_1: require('@/assets/images/pages/card-bg-image-demo-1.jpg'),
      card_bg_img_2: require('@/assets/images/pages/card-bg-image-demo-2.jpg'),
      colorx:'success',
      colorxx:'success',
      value_real: '',
      value_btc: '',
      taxa: '',
      taxa_btc: '',
      total_liquido: '',

      value_real_sell: '',
      value_btc_sell: '',
      taxa_sell: '',
      taxa_btc_sell: '',
      total_liquido_sell: '',

      timer: '',
      timer_orders: '',
      timer_mercado_orders: '',
      cotacao: [],
      ordens_compra: [],
      ordens_venda: [],
      ordens_mercado_compra: [],
      ordens_mercado_venda: [],
      card_2: {
            contentImg2: 'content-img-2.jpg',
            title: 'Vuesax Admin',
            subtitle: 'By Pixinvent Creative Studio',
            footer_text_left_value: '$ 4785.78',
            footer_text_left_label: 'Income',
            footer_text_right_value: '12 June 2019',
            footer_text_right_label: 'Delivery Date',
        },
        money: {
              decimal: ',',
              thousands: '.',
              prefix: 'R$ ',
              suffix: '',
              precision: 2,
              masked: false /* doesn't work with directive */
        },
        crypto: {
              decimal: '.',
            thousands: '',
            prefix: '',
            suffix: '',
            precision: 6,
            masked: false /* doesn't work with directive */
        },
    }
  },
  created () {
        this.fetchEventsList(); 
        this.fetchEventsListOrders();
        this.fetchEventsListOrdersMercadoBTC();
        this.timer = setInterval(this.fetchEventsList, 5000)
        this.timer_orders = setInterval(this.fetchEventsListOrders, 5000)
        this.timer_mercado_orders = setInterval(this.fetchEventsListOrdersMercadoBTC, 5000)
  },
  watch: {
    value_real: function(val) {
        val = this.roundToXDigits(this.parseNumber(val), 2);
        this.value_btc = this.roundToXDigits(val / this.cotacao[0].rate,6);

        // Preço do produto  

       var PRECO = parseFloat(val);  

       // Porcentagem do desconto  

       var PORCENTAGEM1 = parseFloat(0.7);  

      // Valor do desconto  

       var VDESCONTO1 = parseFloat(PRECO*(PORCENTAGEM1/100));


       this.taxa = this.roundToXDigits(VDESCONTO1,2);
       this.taxa_btc = this.roundToXDigits(VDESCONTO1 / this.cotacao[0].rate,6);
       this.total_liquido = this.roundToXDigits(this.roundToXDigits(val / this.cotacao[0].rate,6)-this.taxa_btc,6);

    },
    value_btc_sell: function(val) {
        //val = this.roundToXDigits(this.parseNumber(val), 2);
        var VALOR = val;
        this.value_real_sell = 'R$ '+this.number_format(this.roundToXDigits(val * this.cotacao[0].sell,2), 2, ',', '.');

        // Preço do produto  

       var PRECO = parseFloat(this.roundToXDigits(val * this.cotacao[0].sell,2));  

       // Porcentagem do desconto  

       var PORCENTAGEM1 = parseFloat(0.7);  

      // Valor do desconto  

       var VDESCONTO1 = parseFloat(PRECO*(PORCENTAGEM1/100));


       this.taxa_sell = this.roundToXDigits(VDESCONTO1,2);
       this.taxa_btc_sell = this.roundToXDigits(VDESCONTO1 / this.cotacao[0].sell,6);
       this.total_liquido_sell = this.roundToXDigits(this.roundToXDigits(val * this.cotacao[0].sell,2)-this.taxa_sell,2);

    },
    value_btc: function(val) {
      //this.value_real = val / this.value_real;
    }
  },
  methods: {
        roundToXDigits(value, digits)
        {
          if (!digits) {
            digits = 2;
          }

          value = value * Math.pow(10, digits);
          value = Math.round(value);
          value = value / Math.pow(10, digits);

          return value;
        },
        parseNumber(strg) {
          var strg = strg || "";
          var decimal = '.';
          strg = strg.replace(/[^0-9$.,]/g, '');
          strg = strg.replace('R', '');
          strg = strg.replace('$', '');
          strg = strg.replace(' ', '');
          if(strg.indexOf(',') > strg.indexOf('.')) decimal = ',';
          if((strg.match(new RegExp("\\" + decimal,"g")) || []).length > 1) decimal="";
          if (decimal != "" && (strg.length - strg.indexOf(decimal) - 1 == 3) && strg.indexOf("0" + decimal)!==0) decimal = "";
          strg = strg.replace(new RegExp("[^0-9$" + decimal + "]","g"), "");
          strg = strg.replace(',', '.');
          return parseFloat(strg);
        },
        number_format(number, decimals, decPoint, thousandsSep) {
            number = (number + '').replace(/[^0-9+\-Ee.]/g, '')
            var n = !isFinite(+number) ? 0 : +number
            var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
            var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
            var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
            var s = ''
            var toFixedFix = function (n, prec) {
                var k = Math.pow(10, prec)
                return '' + (Math.round(n * k) / k).toFixed(prec)
            }
            // @todo: for IE parseFloat(0.55).toFixed(0) = 0;
            s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
            if (s[0].length > 3) {
                s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
            }
            if ((s[1] || '').length < prec) {
                s[1] = s[1] || ''
                s[1] += new Array(prec - s[1].length + 1).join('0')
            }
            return s.join(dec)
        },
        fetchEventsList () {
            fetch(this.$store.state.API_URL + 'payment/cryptos/cotacao', {
                method: 'POST',
                headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
                body: "token="+localStorage.getItem("token")
            })
            .then((response) => response.text())
            .then((responseData) => {

                var dados = JSON.parse(responseData);
                this.cotacao = dados;

            });
        },
        fetchEventsListOrders () {
            const thisIns = this;
            fetch(this.$store.state.API_URL + 'Exchange/Info/Orders/BTC', {
                method: 'POST',
                headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
                body: "token="+localStorage.getItem("token")
            })
            .then((response) => response.text())
            .then((responseData) => {

                var dados = JSON.parse(responseData);
                this.ordens_compra = dados.btc.compra;
                this.ordens_venda = dados.btc.venda;

            });
            console.log(this.ordens_compra);
        },
        fetchEventsListOrdersMercadoBTC () {
            fetch(this.$store.state.API_URL + 'Exchange/Market/Orders/BTC', {
                method: 'POST',
                headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
                body: "token="+localStorage.getItem("token")
            })
            .then((response) => response.text())
            .then((responseData) => {

                var dados = JSON.parse(responseData);
                this.ordens_mercado_compra = dados.btc.compra;
                this.ordens_mercado_venda = dados.btc.venda;

            });
        },
        cancelAutoUpdate () { 
            clearInterval(this.timer) 
            clearInterval(this.timer_orders) 
            clearInterval(this.timer_mercado_orders) 
        },
        Comprar () {
            fetch(this.$store.state.API_URL + 'Exchange/Market/Orders/BTC/Buy', {
                method: 'POST',
                headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
                body: "token="+localStorage.getItem("token")+"&value="+this.roundToXDigits(this.parseNumber(this.value_real), 2)
            })
            .then((response) => response.text())
            .then((responseData) => {

                var dados = JSON.parse(responseData);
                if(dados.done)
                {
                    this.$vs.notify({
                        title: 'Exchange',
                        text: dados.message,
                        color: 'success',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }
                else
                {
                    this.$vs.notify({
                        title: 'Exchange',
                        text: dados.message,
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }

            });
        },
        Vender () {
            fetch(this.$store.state.API_URL + 'Exchange/Market/Orders/BTC/Sell', {
                method: 'POST',
                headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
                body: "token="+localStorage.getItem("token")+"&value="+this.value_btc_sell
            })
            .then((response) => response.text())
            .then((responseData) => {

                var dados = JSON.parse(responseData);
                if(dados.done)
                {
                    this.$vs.notify({
                        title: 'Exchange',
                        text: dados.message,
                        color: 'success',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }
                else
                {
                    this.$vs.notify({
                        title: 'Exchange',
                        text: dados.message,
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }

            });
        },
        Depositar () {
            fetch(this.$store.state.API_URL + 'Exchange/Market/Orders/BTC', {
                method: 'POST',
                headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
                body: "token="+localStorage.getItem("token")+"&value="+this.value_btc_sell
            })
            .then((response) => response.text())
            .then((responseData) => {

                var dados = JSON.parse(responseData);
                this.ordens_mercado_compra = dados.btc.compra;
                this.ordens_mercado_venda = dados.btc.venda;

            });
        },
        CancelOrder (id) {
            fetch(this.$store.state.API_URL + 'Exchange/Market/Orders/BTC/Cancel', {
                method: 'POST',
                headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
                body: "token="+localStorage.getItem("token")+"&order="+id
            })
            .then((response) => response.text())
            .then((responseData) => {

                var dados = JSON.parse(responseData);
                if(dados.done)
                {
                    this.$vs.notify({
                        title: 'Exchange',
                        text: dados.message,
                        color: 'success',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }
                else
                {
                    this.$vs.notify({
                        title: 'Exchange',
                        text: dados.message,
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }

            });
        },

    },
    beforeDestroy () {
      clearInterval(this.timer)
      clearInterval(this.timer_orders)
      clearInterval(this.timer_mercado_orders)
    },
  directives: {money: VMoney}
}
</script>